import { useEffect, useState } from 'react'
import { usePostHog } from 'posthog-js/react'

/**
 * Custom hook to check PostHog feature flag for maintenance mode.
 *
 * @param flagName - The name of the PostHog feature flag to check (e.g., 'isMaintenance', 'isPortalMaintenance')
 * @returns boolean | undefined - true if maintenance mode is enabled, false if disabled, undefined while checking
 */
export default function useMaintenanceMode(flagName: string): boolean | undefined {
    const posthog = usePostHog()
    const [isMaintenance, setIsMaintenance] = useState<boolean | undefined>(undefined)

    useEffect(() => {
        if (!posthog) {
            return () => {}
        }

        const isEnabled = posthog.isFeatureEnabled?.(flagName)
        setIsMaintenance(isEnabled === true)

        const unsubscribe = posthog.onFeatureFlags?.(() => {
            const updatedIsEnabled = posthog.isFeatureEnabled?.(flagName)
            setIsMaintenance(updatedIsEnabled === true)
        })

        return () => {
            unsubscribe?.()
        }
    }, [posthog, flagName])

    return isMaintenance
}
